import React from 'react'
import {NavLink} from 'react-router-dom'

/**
 * @desc UserInfo component
 * @desc difference ui between login and logout
 */
const UserInfo = () => {
  const [isLogin, setIsLogin] = React.useState(false)
  return (
    <>
      <div className='flex item-center justify-center text-xs text-slate-50 pt-2'>
        {!isLogin ? (
          <>
            <NavLink
              className='flex item-center justify-center m-auto hover:underline'
              // to='/sign-in'
              onClick={() => setIsLogin(true)}
            >
              Sign In
            </NavLink>
            <span className='item-center justify-center block m-auto hover:cursor-default'>
              &nbsp;/&nbsp;
            </span>
            <NavLink
              className='flex item-center justify-center m-auto hover:underline'
              to='/sign-up'
            >
              Sign Up
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              className='flex item-center justify-center m-auto hover:underline'
              // to=''
              onClick={() => setIsLogin(false)}
            >
              Sign Out
            </NavLink>
          </>
        )}
      </div>
    </>
  )
}

export default UserInfo
